module.exports = __webpack_public_path__ + "public/images/about-exhibition/preview.367daadc03653d484e471a641f5d0794.jpg";